import React from "react";
import {useTranslation} from "react-i18next";
import {timeStyles} from "../../../../selectStyles";
import {CustomNoOptionsMessage} from "./CustomNoOptionsMessage";
import {useDayHours} from "../../../../hooks/useDayHours";
import {useDispatch} from "react-redux";
import Select from "react-select";

export const TimeField = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const dayHours = useDayHours();

    return (<Select id={props.id}
                    name={props.name}
                    styles={timeStyles}
                    classNamePrefix={'time-select'}
                    value={props.value}
                    onChange={(selected) => dispatch(props.onChange(selected))}
                    placeholder={t('choose')}
                    isClearable={props.isClearable}
                    options={dayHours}
                    components={{NoOptionsMessage: CustomNoOptionsMessage}}
                    closeMenuOnSelect={true}
                    menuPlacement={'top'}
                    isSearchable={false}
                    blurInputOnSelect={false}
        />
    );
}